import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, ref} from "vue";
import {onBeforeRouteUpdate, useRouter,} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogUploader from "@/shared/ui/SogUploader.vue";
import apiUsNato from "@/modules/UsNato/api";
import {TempFileInfo} from "@/shared/model/TempFileInfo";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import PersonIds from "@/shared/model/PersonIds";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";



export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const _uploader = ref<InstanceType<typeof SogUploader> | null>(null)

const _title = ref("Bordereau hochladen")
const _spinner = useSpinner()
const _api = apiUsNato
const _array = ref<TempFileInfo[]>([])
const _accountStore = useAccountStore()
const _router = useRouter()


async function p_init() {
  _spinner.show()
  try {
    if (_accountStore.person && _accountStore.person.id !== PersonIds.UsNato && !_accountStore.isRoot) {
      _router.back()
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


async function onImport() {
  if (_array.value.length !== 1)
    return;
  const res = await _api.upload(_array.value[0].fileName);
  if (res) {
    notificationService.success("Datei " + _array.value[0].fileName + " wurde hochgeladen")
    _uploader.value?.clear()
    _spinner.hide()
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Wählen Sie ein Datei aus", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogUploader, {
                ref_key: "_uploader",
                ref: _uploader,
                modelValue: _array.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_array).value = $event)),
                multiple: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-upload",
                onClick: onImport
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" importieren ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _array.value.length>0]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})